/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Red_Busy_Cowfish_TapInputs */

const es_red_busy_cowfish_tap = /** @type {(inputs: Red_Busy_Cowfish_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta creada!`)
};

const gl_red_busy_cowfish_tap = /** @type {(inputs: Red_Busy_Cowfish_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta creada!`)
};

const en_red_busy_cowfish_tap = /** @type {(inputs: Red_Busy_Cowfish_TapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account created!`)
};

/**
* | output |
* | --- |
* | "Account created!" |
*
* @param {Red_Busy_Cowfish_TapInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const red_busy_cowfish_tap = /** @type {((inputs?: Red_Busy_Cowfish_TapInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Red_Busy_Cowfish_TapInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_red_busy_cowfish_tap(inputs)
	if (locale === "en") return en_red_busy_cowfish_tap(inputs)
	return es_red_busy_cowfish_tap(inputs)
});